<template lang="pug">
#modal-bankdetail.modal.fade(tabindex='-1' role='dialog')
  .modal-dialog.modal-dialog-centered.my-0.modal-form
    .modal-content-outside
      .modal-content
        //- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(onclick='location.href='index-logged-in.html'')
        .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0
          .arrow-left
            i.fas.fa-chevron-left
          .modal-title.text-capitalize home
        .d-none.d-md-block.lg-close(data-dismiss='modal')
          i.far.fa-times-circle
        .modal-body.px-4
          .text-center
            .text-uppercase.modal-form-title bank detail
          .d-flex.align-items-center.bankdetail-wrap
            .bankdetail-logo
              img(src='img/bank/bank-cimb.jpg')
            .text-white.pl-2.bankdetail-name.flex-grow-1 LEE HI YENG
            .text-white.bankdetail-number 123456789
          form
            .input-group.mb-4
              label.px-2.input-field Bank Name
              .banklist-select-wrapper.rounded-pill.form-control
                .banklist-select
                  .banklist-select-trigger
                    span
                      img(src='img/bank/bank-cimb.jpg')
                      | CIMB Bank
                  .banklist-options
                    span.banklist-option
                      img(src='img/bank/bank-maybank.jpg')
                      | Maybank
                    span.banklist-option.selected
                      img(src='img/bank/bank-cimb.jpg')
                      | CIMB Bank
                    span.banklist-option
                      img(src='img/bank/bank-rhb.jpg')
                      | RHB Bank
                    span.banklist-option
                      img(src='img/bank/bank-affin.jpg')
                      | Affin Bank
                    span.banklist-option
                      img(src='img/bank/bank-citi.jpg')
                      | Citibank
                    span.banklist-option
                      img(src='img/bank/bank-islam.jpg')
                      | Bank Islam
            .input-group.mb-4
              label.px-2.input-field Bank Account Name
              input.text-center.rounded-pill.form-control(type='text')
            .input-group.mb-4
              label.px-2.input-field Bank Account Number
              input.text-center.rounded-pill.form-control(type='number')
            .input-group.mb-4.input-tac.w-100
              label.px-2.input-field TAC
              input.form-control.text-center.border-tac(type='number')
              .input-group-append
                span.input-group-text.text-uppercase.text-dark resend
            .btn-wrapper
              .btn-profile
                a(href='#' data-dismiss='modal' aria-label='Close')
                  .btn.btn-done cancel
              .btn-profile
                a(href='#')
                  .btn.btn-main save
</template>
<script>
export default {
  
}
</script>